import { render } from "./CardAuthor.vue?vue&type=template&id=1bcd8ebf"
const script = {}

import exportComponent from "C:\\ProjectsLaravel\\nft_imw_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/ts/frontend/components/CardAuthor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bcd8ebf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bcd8ebf', __exports__)) {
    console.log('reload')
    api.reload('1bcd8ebf', __exports__)
  }
  
  module.hot.accept("./CardAuthor.vue?vue&type=template&id=1bcd8ebf", () => {
    console.log('re-render')
    api.rerender('1bcd8ebf', render)
  })

}


export default __exports__